import Link from "next/link";

import BibleVerseItem from "../components/BibleVerseItem";

import useArtists from "../hooks/use-artists";
import useBibleVerse from "../hooks/use-bible-verse";
import VideosSlider from "../components/videos/videos-slider";
import PlaylistSlider from "../components/playlist/playlist-slider";
import ArtistsSlider from "../components/artists/artists-slider";
import SermonsSlider from "../components/sermons/sermons-slider";
import ChurchesSlider from "../components/churches/churches-slider";

import usePaginatedChurches from "../hooks/churches/use-paginated-churches";
import usePaginatedPlaylists from "../hooks/playlists/use-paginated-playlists";
import usePaginatedAudioSermons from "../hooks/sermons/use-paginated-audio-sermons";
import usePaginatedVideoSermons from "../hooks/sermons/use-paginated-video-sermons";
import { useEffect, useState } from "react";
import DailyDevotionItem from "../components/DailyDevotion";
import usePaginatedVideos from "../hooks/videos/use-paginated-videos";
import WhatsNewSlider from "../components/WhatsNewSlider";
import SongsListSlider from "../components/songs/songs-list-slider";
import { CategoryType, EventType } from "../context/analytics-context";
import usePopularSongs from "../hooks/songs/use-popular-songs";
import usePageEvents from "../hooks/use-page-events";
import HeadMeta from "../components/HeadMeta";
import useNewSongs from "../hooks/songs/use-new-songs";

const dailyDevotion = {
  _id: "1",
  reference: "",
  date: "Jan 10",
  title: "Be a living Witness",
  text:
    "<p>When you share your personal experience of your encounter with Christ, you give your friends and peers one of the strongest arguments for becoming a Christian. Only you can testify of what difference Jesus makes in your life. Your mates may contest the relevance of the Bible in this age but cannot contest what has happened to you. They cannot explain away your personal experience of salvation. The testimony of the man born blind in this passage was simple and undeniable. The man boldly relied on his own experience of the power and goodness of Christ to answer the religious leaders who confronted him. They had no choice but to leave him.</p>",
  version: "Jn. 9:1-25",
  numLikes: 0,
  numShares: 0,
  numServed: 0,
  questions: [
    "Is it possible for one to go to church or fellowship, read the Bible regularly and yet remains blind spiritually?",
    "What evidence do you have to convince your mates that you are a Christian?"
  ]
};

export default function Discover() {
  const [greeting, setGreeting] = useState("");

  const videosQuery = usePaginatedVideos();
  const newSongsQuery = useNewSongs();
  const popularSongsQuery = usePopularSongs();
  const playlistsQuery = usePaginatedPlaylists();
  const artistsQuery = useArtists();
  const sermonsQuery = usePaginatedAudioSermons();
  const churchesQuery = usePaginatedChurches();
  const bibleVerseQuery = useBibleVerse();
  const videoSermonsQuery = usePaginatedVideoSermons();

  const sendAnalytics = usePageEvents("discover");

  useEffect(() => {
    const ndate = new Date();
    const hours = ndate.getHours();
    const message = hours < 12 ? "Good Morning" : hours < 18 ? "Good Afternoon" : "Good Evening";

    setGreeting(message);
  }, []);

  const navEvent = (to: string) => {
    sendAnalytics({
      category: CategoryType.NAVIGATION,
      type: EventType.URL_CLICK,
      page: "discover",
      path: to
    });
  };

  return (
    <div className="w-full py-3">
      <HeadMeta title="Discover" url="/discover" />

      <div className="">
        <div className="flex items-center px-3">
          <img src="/app-icons/android-chrome-512x512.png" alt="" className="h-9" />
          <p className="flex-1 text-xl font-semibold text-center text-gray-700">{greeting}</p>
          <p className="flex">
            <span className="pr-2">4</span>
            <img src="/notifications-icon.png" alt="" />
          </p>
        </div>

        {/* New Songs */}
        <div className="mt-2 sm:mt-2">
          <p className="flex items-center p-3">
            <span className="flex-1 text-lg font-bold text-gray-800">What's New</span>

            <Link href="/songs">
              <a onClick={() => navEvent("whats-new")} className="text-xs font-bold">
                View More
              </a>
            </Link>
          </p>

          <WhatsNewSlider
            isLoading={newSongsQuery.isLoading}
            songs={newSongsQuery.data?.slice(0, 10)}
          />
        </div>

        <div className="flex-1 px-3 mt-6 space-x-3-1 overflow-x-auto-1 scoll-snap-x">
          <div className="flex-shrink-0 w-px"></div>

          <div className="flex-shrink-0 max-w-full w-12/12">
            {bibleVerseQuery.isLoading ? (
              <BibleVerseItem type="loading" />
            ) : (
              <BibleVerseItem verse={bibleVerseQuery.data} type="data" />
            )}
          </div>

          <div className="flex-shrink-0 w-px"></div>
        </div>

        <div className="px-3 mt-4">
          <Link href="/bible">
            <a
              onClick={() => navEvent("top-bible")}
              className="flex items-center w-full p-4 bg-gray-900 rounded-xl"
            >
              <img src="/white-book.png" alt="" className="" />
              <div className="px-4 text-white">
                <p className="leading-5 text-justify">
                  Holy Bible <br /> <span className="text-sm font-bold">Read your bible here</span>
                </p>
              </div>
            </a>
          </Link>
        </div>

        {/* Top Playlists */}
        <div className=" sm:mt-2">
          <p className="flex items-center p-3">
            <span className="flex-1 text-lg font-bold text-gray-800">Top Playlists</span>

            <Link href="/playlists">
              <a onClick={() => navEvent("playlists")} className="text-xs font-bold">
                View More
              </a>
            </Link>
          </p>

          <PlaylistSlider playlists={playlistsQuery.data} isLoading={playlistsQuery.isLoading} />
        </div>

        {/* <div className="flex-1 px-3 mt-4 space-x-3-1 overflow-x-auto-1 scoll-snap-x">
          <div className="flex-shrink-0 w-px"></div>

          <div className="flex-shrink-0 max-w-full w-12/12">
            {bibleVerseQuery.isLoading ? (
              <DailyDevotionItem type="loading" />
            ) : (
              <DailyDevotionItem devotion={dailyDevotion} type="data" />
            )}
          </div>

          <div className="flex-shrink-0 w-px"></div>
        </div> */}

        {/* Top Videos */}
        <div className="sm:mt-2">
          <p className="flex items-center p-3">
            <span className="flex-1 text-lg font-bold text-gray-800">Top Videos</span>

            <Link href="/videos/new-music">
              <a onClick={() => navEvent("top-videos")} className="text-xs font-bold">
                Watch All
              </a>
            </Link>
          </p>

          <VideosSlider videos={videosQuery.data} isLoading={videosQuery.isLoading} />
        </div>

        {/* Top Artists */}
        <div className="sm:mt-2">
          <p className="flex items-center p-3">
            <span className="flex-1 text-lg font-bold text-gray-800">Top Artists</span>

            <Link href="/artists">
              <a onClick={() => navEvent("/artists")} className="text-xs font-bold">
                View More
              </a>
            </Link>
          </p>

          <ArtistsSlider artists={artistsQuery.data} isLoading={artistsQuery.isLoading} />
        </div>

        {/* Trending Songs */}
        <div className="sm:mt-2">
          <p className="flex items-center p-3">
            <span className="flex-1 text-lg font-bold text-gray-800">Trending On Angaza</span>

            <Link href="/songs">
              <a onClick={() => navEvent("/songs")} className="text-xs font-bold">
                See All
              </a>
            </Link>
          </p>

          <SongsListSlider
            songs={popularSongsQuery.data?.slice(0, 20)}
            isLoading={popularSongsQuery.isLoading}
          />
        </div>

        {/* Sermons */}
        <div className="sm:mt-2">
          <p className="flex items-center p-3">
            <span className="flex-1 text-lg font-bold text-gray-800">Audio Sermons</span>

            <Link href="/sermons">
              <a onClick={() => navEvent("audio-sermons")} className="text-xs font-bold">
                See All
              </a>
            </Link>
          </p>

          <SermonsSlider sermons={sermonsQuery.data} isLoading={sermonsQuery.isLoading} />
        </div>

        <div className="px-3 mt-4">
          <Link href="/bible">
            <a
              onClick={() => navEvent("bible")}
              className="flex items-center w-full p-4 bg-gray-900 rounded-xl"
            >
              <img src="/white-book.png" alt="" className="" />
              <div className="px-4 text-white">
                <p className="leading-5 text-justify">
                  Holy Bible <br /> <span className="text-sm font-bold">Read your bible here</span>
                </p>
              </div>
            </a>
          </Link>
        </div>

        {/* Popular Churches */}
        <div className="sm:mt-2">
          <p className="flex items-center p-3">
            <span className="flex-1 text-lg font-bold text-gray-800">Popular Churches</span>

            <Link href="/churches">
              <a onClick={() => navEvent("churches")} className="text-xs font-bold">
                See All
              </a>
            </Link>
          </p>

          <ChurchesSlider churches={churchesQuery.data} isLoading={churchesQuery.isLoading} />
        </div>

        {/* Video Sermons */}
        <div className="sm:mt-2">
          <p className="flex items-center p-3">
            <span className="flex-1 text-lg font-bold text-gray-800">Video Sermons</span>

            <Link href="/sermons/video-sermons">
              <a onClick={() => navEvent("video-sermons")} className="text-xs font-bold">
                View More
              </a>
            </Link>
          </p>

          <div className="pb-3">
            <VideosSlider videos={videoSermonsQuery.data} isLoading={videoSermonsQuery.isLoading} />
          </div>
        </div>
      </div>
    </div>
  );
}
